module.exports = __webpack_public_path__ + "img/device-ru.ca41876d.png";